module.exports = function (data) {
    return {
        event: 'BWSAUcompetitionSuccess',
        eventContext: {
            subType: 'competitionSuccess',
            subscription: data.hasOptedIn ? 'true' : 'false',
            compName: data.compName,
            area: data.area
         }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition-success.js
 **/